import { UploadPicture } from 'assets/Modal';
import { Text } from 'shared/Typhography';

interface NoFileProps {
  fileTypes: string[];
  resolution?: { width: number; height: number };
}

export const NoFile = ({ fileTypes, resolution }: NoFileProps) => (
  <>
    <img src={UploadPicture} alt="Upload Image" />
    <Text color="gray" textAlign="center">
      Click here or drag and drop file
    </Text>
    <Text color="gray" textAlign="center">
      Make sure your file is one of the following types:
      <b>{fileTypes.join(', ')}</b>
    </Text>
    {resolution && (
      <Text>
        {resolution?.width}x{resolution.height}
      </Text>
    )}
  </>
);
